import React from "react";
import { getGPUTier } from "detect-gpu";

const GpuTierContext = React.createContext();
GpuTierContext.displayName = "GpuTierCtx";

const GpuTierProvider = ({ children }) => {
  const [tier, setTier] = React.useState(3);

  React.useEffect(() => {
    getGPUTier().then(({ tier }) => setTier(tier));
  }, []);

  return (
    <GpuTierContext.Provider value={tier}>{children}</GpuTierContext.Provider>
  );
};

const useGpuTier = () => React.useContext(GpuTierContext);

export { GpuTierProvider, useGpuTier };
